// @flow
export const getScrollingElement = () =>
  window.document.scrollingElement || window.document.documentElement

export const getElementPosition = (_element: HTMLElement | string) => {
  const scrollingElement = getScrollingElement()

  const element =
    typeof _element === "string" ? window.document.body.querySelector(_element) : _element

  if (!element) return null

  const offsets = element.getBoundingClientRect()

  return {
    top: offsets.top + scrollingElement.scrollTop,
    left: offsets.left,
    bottom: offsets.bottom + scrollingElement.scrollTop,
    right: offsets.right,
  }
}

export const hasBlockedScroll = () => window.document.body.classList.contains("_noscroll")

const getBody = () => window.document.body

const getNavBar = () => {
  const bodyElement = getBody()
  return (
    bodyElement.querySelector(".NitroNavBar > div") ||
    bodyElement.querySelector(".PagesNavbar") ||
    bodyElement.querySelector(".PagesBuddyHeader")
  )
}

export const getMovedTop = () => {
  const bodyElement = getBody()
  const NavBar = getNavBar()

  if (!NavBar) return 0

  const MainView = bodyElement.querySelector(".MainView")

  let movedTop = -parseFloat(MainView.style.top)

  const NavBarStyles = window.getComputedStyle(NavBar)

  if (NavBarStyles.position === "fixed") {
    movedTop += NavBar.clientHeight
  }

  return movedTop
}

export const handleBlockScrollBody = (
  block: boolean,
  // eslint-disable-next-line flowtype/no-weak-types
  callback?: Function,
  extraBodyClass?: string,
): void => {
  if (typeof document === "undefined") return

  const bodyElement = getBody()
  const MainView = bodyElement.querySelector(".MainView")
  const NavBar = getNavBar()

  const NavBarStyles = NavBar ? window.getComputedStyle(NavBar) : {}

  if (block) {
    if (!bodyElement.classList.contains("_noscroll")) {
      const scrollTop =
        window.pageYOffset !== undefined
          ? window.pageYOffset
          : (document.documentElement || bodyElement.parentNode || bodyElement).scrollTop
      let movedTop = -scrollTop

      if (NavBarStyles.position === "fixed") {
        movedTop += NavBar.clientHeight
      }

      if (MainView) {
        MainView.style.top = `${movedTop}px`
      }

      bodyElement.classList.add("_noscroll", extraBodyClass)
    }
  } else {
    if (!bodyElement.classList.contains("_noscroll")) return

    bodyElement.classList.remove("_noscroll", extraBodyClass)

    const movedTop = getMovedTop()

    if (MainView) {
      MainView.style.top = ""
    }

    window.document.scrollingElement.scrollTop = movedTop

    if (callback) {
      callback()
    }
  }
}

export function addScrollHandler(onScrollFunction: () => void, element: Node = document) {
  element.addEventListener("touchmove", onScrollFunction, false)
  element.addEventListener("scroll", onScrollFunction, false)
}

export function removeScrollHandler(onScrollFunction: () => void, element: Node = document) {
  element.removeEventListener("touchmove", onScrollFunction)
  element.removeEventListener("scroll", onScrollFunction)
}

export function adjustScrollHelper(direction: string, place: ?HTMLElement, node: HTMLElement) {
  const placeHeight = place ? place.offsetHeight : 0
  const offsetTop = place ? place.offsetTop : 0

  const modalHeight = node.offsetHeight
  const pickerHeight = modalHeight - placeHeight

  let position
  let difference
  if (direction === "down") {
    position = offsetTop - pickerHeight
    difference = node.scrollTop - position > modalHeight

    if (position > node.scrollTop || difference) {
      return position
    }
  } else {
    position = offsetTop
    difference = node.scrollTop - position < -modalHeight + placeHeight * 2

    if (position < node.scrollTop || difference) {
      return position
    }
  }
  return undefined
}

export function scrollTo(x: number, y: number) {
  try {
    window.scroll({ top: y, behavior: "smooth" })
  } catch (err) {
    // needed here, scroll is in window, but with different signature in electron browser / cypress
    if (err.message.includes("Failed to execute 'scroll' on 'Window'")) {
      window.scroll(x, y) // signature with options object might not be supported - scrollTo works aswell
    } else {
      throw err
    }
  }
}

export type RtlScrollLeftMode = "normal" | "negative" | "reverse"

export function guessScrollLeftMode(element: HTMLElement, isRtl: boolean): RtlScrollLeftMode {
  if (!isRtl) {
    return "normal"
  }

  const scrollLeftBefore = element.scrollLeft

  // eslint-disable-next-line no-param-reassign
  element.scrollLeft = -1

  const { scrollLeft } = element

  // eslint-disable-next-line no-param-reassign
  element.scrollLeft = scrollLeftBefore

  if (scrollLeft < 0) {
    return "negative"
  }

  return scrollLeftBefore > 0 ? "reverse" : "normal"
}

export function getScrollLeft(element: HTMLElement, mode: RtlScrollLeftMode) {
  const { scrollLeft } = element

  if (mode === "reverse") {
    const max = element.scrollWidth - element.clientWidth

    return max - scrollLeft
  }

  return Math.abs(scrollLeft)
}

export function updateScrollLeftBy(
  element: HTMLElement,
  diff: number,
  mode: RtlScrollLeftMode,
  _scrollLeft: number | null = null,
): number {
  const scrollLeft = _scrollLeft === null ? getScrollLeft(element, mode) : _scrollLeft
  const newScrollLeft = scrollLeft + diff

  if (mode === "reverse") {
    const max = element.scrollWidth - element.clientWidth

    return max - newScrollLeft
  }

  return mode === "negative" ? -newScrollLeft : newScrollLeft
}
